import type { PageStore } from './types';

export const initialState: PageStore = {
	activeSchedule: undefined,
	activeOverride: undefined,
	activeRotation: undefined,
	createVariant: undefined,
	overrideVariant: undefined,
	discardVariant: undefined,
	sources: [],
	isEditModeOpen: false,
	isTakeOnCallOpen: false,
	isAddOverrideOpen: false,
	isRevertOverrideOpen: false,
	isDeleteScheduleOpen: false,
	isCreateScheduleOpen: false,
	isDeleteRotationOpen: false,
	isDiscardChangesOpen: false,
};
